@if (show()) {
    @defer (on timer(50ms)) {
        <div class="toast-container"
             [@slideUp]="'in'"
             [attr.data-type]="type()"
             [class.toast-container--progress]="hasProgress()"
             [class.toast-container--completed]="progressCompleted()">

            <!-- ═══ PROGRESS VARIANT (Loading with structured progress) ═══ -->
            @if (hasProgress()) {
                <div class="toast-progress">
                    <div class="toast-progress__circle-wrapper">
                        @if (progressCompleted()) {
                            <svg class="toast-progress__checkmark" viewBox="0 0 44 44">
                                <circle class="checkmark-circle"
                                        cx="22" cy="22" r="18"
                                        fill="none"
                                        stroke="#4CAF50"
                                        stroke-width="2.5"/>
                                <path class="checkmark-path"
                                      d="M12 22l6 6 14-14"
                                      fill="none"
                                      stroke="#4CAF50"
                                      stroke-width="2.5"
                                      stroke-linecap="round"
                                      stroke-linejoin="round"/>
                            </svg>
                        } @else {
                            <svg class="toast-progress__circular" viewBox="0 0 44 44">
                                <circle class="progress-track"
                                        cx="22" cy="22" r="18"
                                        fill="none"
                                        stroke="rgba(255,255,255,0.1)"
                                        stroke-width="3"/>
                                <circle class="progress-fill"
                                        cx="22" cy="22" r="18"
                                        fill="none"
                                        stroke="#4CAF50"
                                        stroke-width="3"
                                        stroke-linecap="round"
                                        [attr.stroke-dasharray]="circleDasharray()"
                                        stroke-dashoffset="0"
                                        transform="rotate(-90 22 22)"/>
                            </svg>
                            <span class="toast-progress__percentage">{{ progressPercentage() }}%</span>
                        }
                    </div>

                    <div class="toast-progress__content">
                        <div class="toast-progress__header">
                            <span class="toast-progress__title">
                                {{ progressTitle() || message() }}
                            </span>
                            @if (!progressCompleted()) {
                                <span class="toast-progress__badge">
                                    {{ progressCurrent() }}/{{ progressTotal() }}
                                </span>
                            }
                        </div>
                        @if (!progressCompleted()) {
                            <span class="toast-progress__step">{{ progressStep() }}</span>
                        }
                        <div class="toast-progress__bar-track">
                            <div class="toast-progress__bar-fill"
                                 [style.width.%]="progressPercentage()"
                                 [class.toast-progress__bar-fill--complete]="progressCompleted()">
                            </div>
                        </div>
                    </div>
                </div>
            }

            <!-- ═══ DEFAULT VARIANT (success/error/info/warning/simple loading) ═══ -->
            @else {
                <app-flex align="center" [gap]="15">
                    <div class="toast-container__icon-wrapper">
                        @switch (type()) {
                            @case ('success') {
                                <app-icon icon="success" color="#ffffff" />
                            }
                            @case ('info') {
                                <app-icon icon="info" color="#ffffff" />
                            }
                            @case ('loading') {
                                <svg class="toast-container__loading-icon" viewBox="0 0 50 50">
                                    <circle class="loading-ring"
                                            cx="25"
                                            cy="25"
                                            r="20"
                                            fill="none"
                                            stroke="white"
                                            stroke-width="4"
                                            stroke-linecap="round"/>
                                </svg>
                            }
                            @case ('alert') {
                                <app-icon icon="alert" color="#ffffff" />
                            }
                            @case ('error') {
                                <app-icon icon="alert" color="#ffffff" />
                            }
                            @case ('warning') {
                                <app-icon icon="alert" color="#ffffff" />
                            }
                            @default {
                                <app-icon icon="success" color="#ffffff" />
                            }
                        }
                    </div>
                    <span class="toast-container__message-wrapper">
                        {{ message() }}
                    </span>
                </app-flex>
            }
        </div>
    }
}
